<template>
	<div class="plugin-new-container">
		<div class="row mb-8 mt-4 row-explain">
			<p>{{ getString('plugin_dev_explain') }}<a class="ml-6" href="https://qromo.stoplight.io/docs/qromo-plugins/n3e5ulr69abw4-plugin-flow" target="_blank">{{ getString('documentation') }}</a></p>
		</div>
		<AppList :items="items" >
			<template v-slot:input-text="{item}">
				<div class="row list-row">
					<p class="list-item-title">{{ item.title }}</p>
					<AppTextInput class="text-input" :placeholder="item.title" @changed-text="item.callback" />
				</div>
			</template>
			<template #image-slot="{item}">
				<div class="row centered space-between image-slot">
					<p class="list-item-title">{{ item.title }}</p>
					<AppDropzone
						:max-bytes="100 * 1024"
						:max-width="300"
						:max-height="300"
						@removed-file="icon = ''"
						@upload-complete="item.callback" />
				</div>
			</template>
			<template #color-slot="{item}">
				<div class="row centered space-between color-slot">
					<p class="list-item-title">{{ item.title }}</p>
					<AppColorPicker :ref="item.ref" :value="item.color" @changed-color="item.callback" />
				</div>
			</template>
		</AppList>
		<div class="row centered flex-end mt-20">
			<AppButton :text="getString('save')" @click="addPlugin" />
		</div>
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppDropzone from "@/shared/components/AppDropzone.vue";
import AppColorPicker from "@/shared/components/AppColorPicker.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {validateLink} from "@/shared/helpers/strings";
import {useUserStore} from "@/console-new/stores";
import API from '@/shared/helpers/API.js';

export default {
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const userStore = useUserStore();
		return {
			getString: languageStore.getString,
			notificationStore,
			userStore
		};
	},
	name: "PluginNew",
	emits: ["added-plugin"],
	components: {AppColorPicker, AppDropzone, AppTextInput, AppList, AppButton},
	data() {
		return {
			name: "",
			description: "",
			activeUrl: "",
			secret: false,
			color: "#0752a3",
			icon: ""
		};
	},
	computed: {
		items() {
			return [
				{
					title: this.getString("name"),
					customSlot: "input-text",
					callback: (value) => {
						this.name = value;
					}
				},
				{
					title: this.getString("description"),
					customSlot: "input-text",
					callback: (value) => {
						this.description = value;
					}
				},
				{
					title: this.getString("activation_url"),
					customSlot: "input-text",
					callback: (value) => {
						this.activeUrl = value;
					}
				},
				{
					title: this.getString("require_secret"),
					explain: this.getString("require_secret_explain"),
					switch: true,
					callback: (value) => {
						this.secret = value;
					}
				},
				{
					title: this.getString("color"),
					customSlot: "color-slot",
					placeholder: this.getString("color"),
					color: "#0752a3",
					ref: "color",
					callback: (value) => {
						this.color = value;
					}
				},
				{
					title: this.getString("custom_icon"),
					customSlot: "image-slot",
					explain: this.getString("suggested_res_icon"),
					callback: (files) => {
						this.icon = files.length > 0 ? files[0] : "";
					}
				},
			];
		}
	},
	methods: {
		addPlugin() {
			let name = this.name;
			if (name.length < 3) {
				this.notificationStore.showNotification("plugin-name-invalid");
				return;
			}

			let activeUrl = this.activeUrl;
			if(!validateLink(activeUrl)) {
				this.notificationStore.showNotification("plugin-url-invalid");
				return;
			}


			let description = this.description;
			if (description.length < 3) {
				description = null;
			}

			let color = this.color.replace("#", "");
			let icon = this.icon;
			if(!validateLink(icon)) {
				icon = null;
			}

			API.init().addPlugin(this.userStore.currBusinessId, name, description, activeUrl, color, icon, this.secret, (r) => {
				if(r && r.result && r.result === "OK") {
					this.notificationStore.showNotification("generic-success");
					this.$emit("added-plugin", r.client_id, r.client_secret);
				} else if(r && r.result && r.result === "KO" && r.details && r.details === "invalid_url") {
					this.notificationStore.showNotification("plugin-url-invalid");
				} else {
					this.notificationStore.showNotification("generic-error");
				}
			});

		}
	}
}
</script>

<style scoped lang="scss">
.list-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
.list-item-title {
	max-width: calc(100% - 105px);
	font-size: 16px;

	@media (max-width: 560px) {
		font-size: 14px;
	}
	@media (max-width: 400px) {
		font-size: 12px;
	}
	@media (max-width: 350px) {
		max-width: 100%;
		width: 100%;
	}
}
.image-slot {
	flex-wrap: nowrap;
	padding-top: 8px;
}
.extra-text {
	p {
		font-size: 14px;
		color: #9B9B9B;
	}
}
.color-slot .list-item-title {
	width: calc(100% - 45px);
}
.row-explain {
	p {
		font-size: 14px;
		color: #9B9B9B;
	}
}
</style>